import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-form-properties-dialog',
  templateUrl: './form-properties-dialog.component.html',
  styleUrls: ['./form-properties-dialog.component.scss']
})
export class FormPropertiesDialogComponent implements OnInit {
  properties: any;
  minDate = new Date();
  automations: any;
  departmentEmails: any[];
  @ViewChild('emailInput', {static: false}) emailInput: ElementRef;
  @ViewChild('emailInput1', {static: false}) emailInput1: ElementRef;
  separatorKeysCodes = [ENTER, COMMA];

  emailsCtrl = new FormControl();
  emailsCtrl1 = new FormControl();

  filteredEmails: Observable<any[]>;
  emails: any[] = [];
  emails1: any[] = [];
  selectable = true;
  removable = true;
  addOnBlur = false;
  constructor(private commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              public dialogRef: MatDialogRef<FormPropertiesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.properties = data;
    console.log(this.properties);
  }

  async ngOnInit() {
    try {
      await this.initAutomations();
      await this.initDepartmentEmails();
      this.filteredEmails = this.emailsCtrl.valueChanges.pipe(
          startWith(null),
          map((email: any | null) => email ? this.filter(email) : this.departmentEmails.slice()));
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initAutomations() {
    try {
      const automationsRequest = await this.commonService.getList('automation');
      for (const automation of automationsRequest.object) {
        automation.selected = false;
        automation.emails = [];
      }
      this.automations = automationsRequest.object;
    } catch (e) {
      throw e;
    }
  }
  async initDepartmentEmails() {
    try {
      const result = await this.commonService.getList(`college/emails`);
      this.departmentEmails = result.object;

    } catch (e) {
      throw e;
    }
  }

  close() {
    this.dialogRef.close();
  }

  //#region autocomplete section
  removeEmail(email: any) {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  removeEmail1(email: any) {
    const index = this.emails1.indexOf(email);

    if (index >= 0) {
      this.emails1.splice(index, 1);
    }
  }

  addEmail($event: any) {
    // @ts-ignore
    const input = event.input;
    // @ts-ignore
    const value = event.value;

    // Add email
    if ((value || '').trim()) {
      this.emails.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.emailsCtrl.setValue(null);
  }

  addEmail1($event: any) {
    // @ts-ignore
    const input = event.input;
    // @ts-ignore
    const value = event.value;

    // Add email
    if ((value || '').trim()) {
      this.emails1.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.emailsCtrl1.setValue(null);
  }

  filter(name: string) {
    try {
      if (name) {
        return this.departmentEmails.filter(email =>
            email.email.toLowerCase().indexOf(name.toLowerCase()) === 0);
      }
    } catch (e) {

    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.emails.push(event.option.viewValue);
    this.emailInput.nativeElement.value = '';
    this.emailsCtrl.setValue(null);
  }

  selected1(event: MatAutocompleteSelectedEvent): void {
    this.emails1.push(event.option.viewValue);
    this.emailInput1.nativeElement.value = '';
    this.emailsCtrl1.setValue(null);
  }
  //#endregion
}
